module.exports = __webpack_public_path__ + "static/media/tron_6.38739b81.gif";